import apiClient from "@/shared/api/apiClient2";

export const getLogList = async (tx_id, params) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/transactions/${tx_id}/logs`,
      { params }
    );
    return data;
  } catch (e) {
    console.error("[logging] getLogList", e);
  }
};

export const getEntityLogList = async (params) => {
  try {
    const { data } = await apiClient.get("/api/v1/log-entry/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("[logging] getEntityLogList", e);
  }
};
